import React, { useState } from "react";
import "./Header.css";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartShopping,
  faHeart,
  faMagnifyingGlass,
  faUser,
} from "@fortawesome/free-solid-svg-icons";

function Header() {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false); // state to control navbar toggle

  const handleNavClick = () => {
    setExpanded(false);
  };

  return (
    <>
      <section className="main_head">
        <div className="container-fluid p-0">
          <div className="container-md">
            <Navbar expand="lg" expanded={expanded} onToggle={setExpanded}>
              <Navbar.Brand href="#home">
                <div className="logodiv">
                  <Link to="/">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/assets/images/logo/logo.png"
                      }
                      alt="Logo"
                      className="logo-img"
                    />
                  </Link>
                </div>
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />

              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="">
                  <Nav.Link
                    as={Link}
                    to="/"
                    className={location.pathname === "/" ? "active" : ""}
                    onClick={handleNavClick}
                  >
                    Home
                  </Nav.Link>

                  <Nav.Link
                    as={Link}
                    to="/about-us"
                    className={
                      location.pathname === "/about-us" ? "active" : ""
                    }
                    onClick={handleNavClick}
                  >
                    About Us
                  </Nav.Link>

                  <NavDropdown title="SERVICES" id="basic-nav-dropdown">

                    <NavDropdown.Item href="/services/furniture-custom-carpentry">
                      <p className="inner_text">Furniture & Custom Carpentry</p>
                    </NavDropdown.Item>

                    <NavDropdown.Item href="/services/modular-kitchens">
                      <p className="inner_text">Modular Kitchens</p>
                    </NavDropdown.Item>

                    <NavDropdown.Item href="/services/acoustic-theatre-design">
                      <p className="inner_text">
                        Acoustic & Home Theatre Design{" "}
                      </p>
                    </NavDropdown.Item>

                    <NavDropdown.Item href="/services/civil-renovation-work">
                      <p className="inner_text">Civil & Renovation Work</p>
                    </NavDropdown.Item>

                    <NavDropdown.Item href="/services/false-ceiling-designs">
                      <p className="inner_text">False Ceiling & POP Designs </p>
                    </NavDropdown.Item>

                    <NavDropdown.Item href="/services/professional-painting-services">
                      <p className="inner_text">
                        {" "}
                        Professional Painting Services{" "}
                      </p>
                    </NavDropdown.Item>

                    <NavDropdown.Item href="/services/home-automation">
                      <p className="inner_text"> Home Automation </p>
                    </NavDropdown.Item>
                    
                    <NavDropdown.Item href="/services/3D-designing-visualization">
                      <p className="inner_text">
                        {" "}
                        3D Designing & Visualization{" "}
                      </p>
                    </NavDropdown.Item>
                  </NavDropdown>

                  <Nav.Link
                    as={Link}
                    to="/projects"
                    className={
                      location.pathname === "/projects" ? "active" : ""
                    }
                    onClick={handleNavClick}
                  >
                    PROJECTS
                  </Nav.Link>

                  <Nav.Link
                    as={Link}
                    to="/contact-us"
                    className={
                      location.pathname === "/contact-us" ? "active" : ""
                    }
                    onClick={handleNavClick}
                  >
                    Contact Us
                  </Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </div>
        </div>
      </section>
    </>
  );
}

export default Header;
